import React, { useEffect, useState } from "react";
import Header from "../../../SharedFiles/Header/Header";
import Footer from "../../../SharedFiles/Footer/Footer";
import ITTable from "./ITTable";
import { useDispatch, useSelector } from "react-redux";
import {
  GetTestITData,
  GetItemByBatch,
  postITR,
  GetToWhs,
} from "../../../APIServices/ProductionService/ITServices/ITThunk";
import {
  BarLoader,
  CircleLoader,
  ClimbingBoxLoader,
  FadeLoader,
  HashLoader,
  PacmanLoader,
  PuffLoader,
  RingLoader,
  ScaleLoader,
} from "react-spinners";
import ITInput from "./ITInput";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import "./IT.css";
import {
  showNavigateConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useTranslation } from 'react-i18next';

const ITMain = () => {
  const dispatch = useDispatch();
  const {
    TestITData,
    ITItemData,
    postResponse,
    GetToWarehouse,
    loading,
    error,
  } = useSelector((state) => state.InvTransfer || {});
  const [openManual, setOpenManual] = useState(false);
  const [disabledFields, setDisabledFields] = useState([]);
  const [inputValues, setInputValues] = useState({
    item_Code: "",
    batch_Number: "",
  });
  const [scanmodalVisible, setScanModalVisible] = useState(true);
  const [tableBody, setTableBody] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [QrTrigger, setQrTrigger] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [scannedBatchNumber, setScannedBatchNumber] = useState(null);

  const [callInProgress, setCallInProgress] = useState({
    ItPost: false,
    ItData: false,
    WhsData: false,
    ItemDataByBatch: false,
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({});
  const isLoading = () => {
    // Check if any loading state is true
    return (
      loading.TestITData ||
      loading.ITItemData ||
      loading.GetToWarehouse ||
      loading.postResponse
    );
  };
//   useEffect(() => {
//     if (QrTrigger) {
//       const item = inputValues;
//       if(item.length===0){
// toast.error("No dat Available in QR");
//       }else{
//         const header = "batch_Number";
//         handleSelectSuggestion(item, header);
//         setOpenManual(true);
//         setQrTrigger(false);
//       }

      
//     }
//   }, [QrTrigger]);

  useEffect(() => {
    if (ITItemData && ITItemData.length > 0 && callInProgress.ItemDataByBatch) {
      setFormData(ITItemData[0]);
      setCallInProgress((prev) => ({
        ...prev,
        ItemDataByBatch: true,
      }));
    }
  }, [ITItemData]);

  // Table header creation
  const modelfield =
    ITItemData && ITItemData.length > 0
      ? [
          ...Object.keys(ITItemData[0]).filter(
            (key) =>
              key !== "absEntry" &&
              key !== "batch_Number" &&
              key !== "item_Code" &&
              key!=="item_Name"
          ),
          "toWhs",
        ]
      : [];

  const inputfieldLabel = ["item_Code","item_Name", "batch_Number"];
  const batchChecker = () => {
    if (callInProgress.ItemDataByBatch && error.ITItemDataError) {
      const errorss = error.ITItemDataError;
      const status = errorss.errorCode;
      const errormessage = errorss.errorMessage;
      setCallInProgress({ ...callInProgress, ItemDataByBatch: false });
      if (status === 404) {
        toast.error(errormessage);
      }
    }
    if (callInProgress.WhsData && error.GetToWarehouseError) {
      toast.error("Error Fetching Warehouse");
      setCallInProgress((prev) => ({
        ...prev,
        WhsData: false,
      }));
    }
    if (callInProgress.ItData && error.TestITDataError) {
      toast.error("Error fetching IT Data"); // Show toast error
      setCallInProgress((prev) => ({
        ...prev,
        ItData: false, // Reset loading state in case of error
      }));
    }
  };

  useEffect(() => {
    batchChecker(); // Call batchChecker every time DisassembleBatch or error changes
  }, [ITItemData, GetToWarehouse, TestITData, loading, error, callInProgress]);

  useEffect(() => {
    if(!scannedBatchNumber || !TestITData) return;
    const allKeys = Object.keys(TestITData);
    const firstKey = allKeys[0];
    const items = TestITData[firstKey];

    if(Array.isArray(items) && items.length > 0) {
      handleSelectSuggestion(items[0], "batch_Number");
      setOpenManual(true);
      setScannedBatchNumber(null);
    }
  }, [TestITData, scannedBatchNumber]);

  const handleSelectSuggestion = (item, header) => {    
    setFormData({});
    let updatedValues = [];
    if (header === "item_Code") {
      updatedValues = {
        ...inputValues,
        item_Code: item.item_Code,
        item_Name:item.item_Name,
        batch_Number: "",
      };
    }else if(header === "item_Name"){
        updatedValues = {
          ...inputValues,
          item_Code: item.item_Code,
          item_Name:item.item_Name,
          batch_Number: item.batch_Number,
          batch_Number: "",
        };
      
    } else if (header === "batch_Number") {
      updatedValues = {
        ...inputValues,
        batch_Number: item.batch_Number,
        item_Code: item.item_Code,
        item_Name:item.item_Name,
      };
    }
    setInputValues(updatedValues);
    setDisabledFields(["from_Whs", "quantity"]);
    if (updatedValues.item_Code && updatedValues.batch_Number) {
      setCallInProgress((prev) => ({
        ...prev,
        ItemDataByBatch: true,
      }));
      dispatch(
        GetItemByBatch({
          item_Code: updatedValues.item_Code,
          batch_Number: updatedValues.batch_Number,
        })
      );
      setScanModalVisible(true);
        setCallInProgress((prev) => ({
          ...prev,
          WhsData:true,
        }));
        dispatch(GetToWhs());
    }
  };
  const onEdit = (action, index) => {
    const selectedRow = tableBody[index];
    setFormData(selectedRow);
    setInputValues({
      item_Code: selectedRow.item_Code,
      item_Name:selectedRow.item_Name,
      batch_Number: selectedRow.batch_Number,
    });
    setRowIndex(index);
    setDisabledFields(["item_Code", "item_Name","from_Whs", "quantity"])
    setScanModalVisible(true);
    setEditMode(true); // Enable edit mode
  };

  const handleSubmitModalData = (formData) => {

    const existingBatchNumber = tableBody.some(
      (row) => row.batch_Number === formData.batch_Number
    );
    let newErrorMessage = {};
    const isWhsValid = GetToWarehouse.some(item => item.whs_Code=== formData.toWhs
    );
    if (!isWhsValid) {
      newErrorMessage.toWhs= `Warehouse ${formData.toWhs} not exists.`;
    }
    if (Object.keys(newErrorMessage).length > 0) {
      setErrorMessage(newErrorMessage);
      return;
  }
    if (!editMode && existingBatchNumber) {
      toast.error("Batch number already exists!");
      setInputValues({ item_Code: "", batch_Number: "" });
      setScanModalVisible(true);
      return;
    }
    if (formData.from_Whs === formData.toWhs) {
      toast.error("From Whs and To whs is not same ");
      setScanModalVisible(true);
      return;
    }
    if (formData && Object.keys(formData).length > 0) {
      setTableHeader(Object.keys(formData).filter((key) => key !== "absEntry")); // Update header if needed
    } else {
      setTableHeader([]);
    }
    if (editMode) {
      setTableBody((prevTableBody) =>
        prevTableBody.map((row, index) => (index === rowIndex ? formData : row))
      );
    } else {
      setTableBody((prevTableBody) => [...prevTableBody, formData]); // Add new row if not in edit mode
    }
    setInputValues({ item_Code: "", batch_Number: "" });
    setFormData({});
    setScanModalVisible(false);
    setErrorMessage({})
    setEditMode(false);
  };

  // Handle table data submission
  const handleSubmitTableData = () => {
    showSubmitConfirmation(() => {
      setCallInProgress((prev) => ({
        ...prev,
        ItPost: true,
      }));
      const datapost = tableBody.map((row) => ({
        ...row,
        remarks: remarks,
      }));
      dispatch(postITR(datapost));
    });
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value); // Update "Remarks"
  };

  useEffect(() => {
    if (callInProgress.ItPost && postResponse === "Success") {
      setCallInProgress((prev) => ({
        ...prev,
        ItPost: false,
      }));
      toast.success("Submitted successfully!");
      setFormData({});
      setTableBody([]);
      setTableHeader([]);
      setScanModalVisible(true);
    }
    if (callInProgress.ItPost && error.postResponseError) {
      setCallInProgress((prev) => ({
        ...prev,
        ItPost: false,
      }));
      const errormessage = error.postResponseError;
      toast.error(`${errormessage.errorMessage}`);
    }
  }, [postResponse, error, callInProgress]);

  const handleQrScan = (scanResult) => {
    // let data;
    // try {
    //     data = JSON.parse(scanResult);
    // } catch (err) {
    //     console.error("Invalid QR scan result:", err);
    //     return;
    // }
    // const batchNumber = data?.Batch_Number?.trim();
    const batchNumber = scanResult?.["batchnumber"]?.trim();
    if (!batchNumber) {
        toast.error(t('Batch Number not found!'));
        return;
    }else{
      dispatch(
        GetTestITData({
          search_term:batchNumber,
          prev_value: "",
          search_field: "batch_Number",
        })
      );
    }
    const header = "batch_Number";
    setScannedBatchNumber(true);
    // handleSelectSuggestion(TestITData, header);
      setOpenManual(true);
  };

  const handleAdd = () => {
    setScanModalVisible(true);
    setEditMode(false);
  };

  const handleScanModeClose = () => {
    setInputValues({});
    setFormData({});
    setDisabledFields([])
    if (tableBody && tableBody.length > 0) {
      setScanModalVisible(false);
    } else {
      navigate("/production/");
    }
  };

  const handleNavigateConfirmation = () => {
    if (tableBody.length > 0) {
      showNavigateConfirmation(goBack);
    } else {
      goBack();
    }
  };

  const goBack = () => {
    navigate("/production/");
  };

  return (
    <>
      {/* <Header /> */}
      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
          <button onClick={handleNavigateConfirmation} className="goBackButton">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">{t('INVENTORY TRANSFER')}</p>
        </div>
        <ITInput
          editMode={editMode}
          disabledFields={disabledFields}
          inputfieldLabel={inputfieldLabel}
          inputValues={inputValues}
          setInputValues={setInputValues}
          handleScanModeClose={handleScanModeClose}
          handleSelectSuggestion={handleSelectSuggestion}
          setOpenManual={setOpenManual}
          openManual={openManual}
          scanmodalVisible={scanmodalVisible}
          handleQrScan={handleQrScan}
          setScanModalVisible={setScanModalVisible}
          handleSubmit={handleSubmitModalData}
          modelfields={modelfield}
          setFormData={setFormData}
          formData={formData}
          setErrorMessage={setErrorMessage}
          errorMessage={errorMessage}
          callInProgress={callInProgress}
        />
        <div className="row mb-1">
          <div className="col-12 d-flex justify-content-end">
            {tableBody.length > 0 && (
              <button className="button xs" onClick={handleAdd}>
                {t('Add Item')}
              </button>
            )}
          </div>
        </div>

        <div className="tableMin">
          <ITTable
            tableHeader={tableHeader}
            tablebody={tableBody}
            setTableBody={setTableBody}
            onEdit={onEdit}
            pageName={"InventoryTransfer"}
            setScanModalVisible={setScanModalVisible}
          />
        </div>

        <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
          {tableBody.length > 0 && (
            <>
              <input
                type="text"
                value={remarks}
                placeholder={t('Remarks')}
                onChange={handleRemarksChange}
                className="form-control custom-input"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  width: "240px",
                  marginTop: "5px",
                }}
              />
              <button onClick={handleSubmitTableData} className="button xs">
              {t('Submit')}
              </button>
            </>
          )}
        </div>
      </div>
      <Footer />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
      <div>
        {isLoading() && (
          <div className="loader">
            <HashLoader color="#ed1c24" />
          </div>
        )}
      </div>
    </>
  );
};

export default ITMain;
